<template>
  <div class="hoilday">
    <div class='hoildaybody' v-if="!isKR">
      <img class="hoildayhead" src="/static/images/activty/festival/newyear/app_newyear/head.png">
      <div class="hoildaytext">
        <ul>
          <li>
            <div><strong>Dear CARDHOBBY users, </strong></div>During the 2024 Spring Festival, our China office and warehouse schedule is as follows:
            We will be on holiday from February 9, 2024 (Friday) to February 17, 2024 (Saturday), a total of 9 days. We will resume work on February 18, 2024 (Sunday). U.S. offices not affected by holidays.
          </li>
          <li class="m20">
            <div>Customer Service:</div>
            When you encounter any problems during transactions, please contact customer service via email.
          </li>
          <li>
            <p>If you are a buyer, please contact: <a class="mail" href="mailto:buyerquestions.us@cardhobby.com">buyerquestions.us@cardhobby.com</a></p>
            <p>If you are a seller, please contact: <a class="mail" href="mailto:sellerquestions.us@cardhobby.com">sellerquestions.us@cardhobby.com</a></p>
          </li>
          <li>
            <div>Cross-border transactions:</div>
            China Office will suspend the inspection of cross-border orders from <span class="red">February 9, 2024 (Friday) to February 17, 2024 (Saturday).</span> Therefore, Buyer may consider adjusting the logistics of transactions during this period. The inspection of all cross-border transactions will resume on <span class="red">February 18, 2024 (Sunday).</span>
          </li>
          <li>Finally, we would like to express our gratitude to all users for their continued support and understanding over the past year. The entire staff of CARD HOBBY wishes you an auspicious Year of the Dragon and may you enjoy the joy of collecting cards.</li>
          <li class="m20">CARDHOOY OFFICE</li>
        </ul>
      </div>
    </div>
    <div class='hoildaybody' v-if="isKR">
      <img class="hoildayhead" src="/static/images/activty/festival/newyear/app_newyear/head.png">
      <div class="hoildaytext">
        <ul>
          <li>
            <div><strong>카드하비 코리아 이용자 여러분,</strong></div>2024 설 기간 동안 중국 사무실 및 창고 일정은 다음과 같습니다:<br />
            2024년 2월 9일 (금요일)부터 2024년 2월 17일 (토요일)까지 총 9일간 휴가가 예정되어 있습니다
            2024년 2월 18일 (일요일)부터 업무를 재개할 예정이며, 미국 사무실은 휴일 영향을 받지 않습니다.
            한국 사무실은 2월 9일부터 2월 12일까지 영업하지 않습니다
          </li>
          <li class="m20">
            <div>고객 서비스:</div>
            이용에 문제가 발생하면 이메일을 통해 고객 서비스에 문의 부탁드립니다
          </li>
          <li>
            <p>문의 메일: <a class="mail" href="mailto:cs@cardhobby.kr">cs@cardhobby.kr</a></p>
          </li>
          <li>
            <div>국제 거래 관련: </div>
            중국 사무실은 <span class="red">2024년 2월 9일 (금요일)부터 2024년 2월 17일 (토요일)</span> 까지 국제 거래 관련 업무가 중단됩니다.따라서 한국/미국 구매자 분들은 택배 수령에 좀 더 시간이 걸릴 수 있습니다.모든 국제 거래 관련 업무는 <span class="red">2024년 2월 18일 (일요일)</span>에 재개됩니다.
          </li>
          <li>카드하비 코리아의 성공을 기원하는 응원에항상 감사드리며. 전 세계 CARD HOBBY의 전 직원들이 여러분에게 행운의 2024년을 기원하며 카드 수집의 즐거움을 누리시기를 기원합니다.</li>
          <li class="m20">-CARD HOBBY-</li>
        </ul>
      </div>
    </div>
    <div class="hoildayfoot"></div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      isKR: false
    }
  },
  watch: {},
  mounted() {},
  created() {
    if (this.$route.params.id == 'KR') {
      this.isKR = true
    }
    console.log(this.$route.params.id, '1231')
    this.$store.commit('SET_HEADER_TITLE', this.$t('base.notice'));
  },
  methods: {

  },
}

</script>
<style scoped>
.hoilday {
  margin-bottom: -35px;
  background: #FFFAEE url(/static/images/activty/festival/newyear/newyear/bg.png) center;
  background-blend-mode: multiply;
}

.hoildayfoot {
  height: 37px;
  background: url(/static/images/activty/festival/newyear/app_newyear/foot.png) center;
  background-size: auto 100%;
}

.hoilday .hoildaybody {
  width: 800px;
  margin: 100px auto 200px;
}

.hoildaytext {
  background: url(/static/images/activty/festival/newyear/app_newyear/boom.png) 90% 100% no-repeat;
  background-size: 54px 54px;
  padding-bottom: 38px;
  margin-bottom: 20px;
}

.hoildaybody li {
  font-size: 14px;
  line-height: 1.5;
}

.hoildaybody .mail {
  text-decoration: underline;
}

.hoildaybody .red {
  font-weight: 700;
  color: #E90913;
}

.hoildayhead {
  margin: 12px auto;
  display: block;
}


.m20 {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/festival/midautumn.vue